import { css } from "@compiled/react";
import { UniformSlot } from "@uniformdev/canvas-react";

import { wacToken } from "@/libraries/design/foundations";

const rowStyle = css({
    lineHeight: "1",
    fontFamily:
        "Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif",
    color: wacToken("color.extended.blue1000"),
    borderCollapse: "collapse",
    borderSpacing: "0",
    boxSizing: "inherit",
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline",
    borderBlockEnd: "2px solid wacToken(color.neutral.light200)"
});

const versionContainerStyle = css({
    display: "flex",
    flexDirection: "column"
});

const releaseNotesStyle = css({
    fontSize: "0.875em",
    marginBlockStart: "6px"
});

const cellStyle = css({
    padding: "10px 8px",
    textAlign: "center"
});

const firstCellStyle = css({
    textAlign: "left"
});
export interface UniformDownloadRowProps {
    size: string;
    date: string;
}

const UniformDownloadRow = ({ size, date }: UniformDownloadRowProps) => {
    return (
        <tr css={rowStyle}>
            <td className="p" css={[cellStyle, firstCellStyle]}>
                <div css={versionContainerStyle}>
                    <UniformSlot name="version" />
                    <small css={releaseNotesStyle}>
                        <UniformSlot name="releaseNotes" />
                    </small>
                </div>
            </td>
            <td className="p" css={cellStyle}>
                {size}
            </td>
            <td className="p" css={cellStyle}>
                {date}
            </td>
            <td className="p" css={cellStyle}>
                <UniformSlot name="format" />
            </td>
        </tr>
    );
};

export default UniformDownloadRow;
